import { render } from "./Hinweis.vue?vue&type=template&id=534533f4&scoped=true"
import script from "./Hinweis.vue?vue&type=script&lang=js"
export * from "./Hinweis.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Bleckmann\\lions-adventskalender-frontend-bocholt\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534533f4"]])

export default __exports__